module.exports = "/_next/static/images/d80854e9bda3b0a3a447b8ce461a11b3-challenge-the-system-lg@1x.jpg.webp";